export default __webpack_public_path__ + "static/media/logo.b9f957a6.png";